import React, { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useThemeType } from '../../hooks/useThemeType'
import { useBackgroundContext } from './provider'

function Background ({ children, light, dark }) {
  const { setBackground } = useBackgroundContext()

  const themeType = useThemeType()
  const bg = useMemo(() => {
    if (themeType === 'light') {
      return light
    }
    if (themeType === 'dark') {
      return dark
    }
    return undefined
  }, [themeType, light, dark])

  useEffect(() => {
    if (bg) {
      setBackground(bg)
    }
  }, [bg, setBackground])

  return (
    <>
      {children}
    </>
  )
}

Background.propTypes = {
  children: PropTypes.node,
  light: PropTypes.string,
  dark: PropTypes.string
}

export default Background
